/**************************************************
 * Nombre:       Formulario_Categoria_Formacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {ScatterPlotOutlined} from "@mui/icons-material";

const Formulario_Categoria_Formacion = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={ScatterPlotOutlined} nombre={'Nombre de categoria formación'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Categoria_Formacion